/**
 * @generated SignedSource<<f154bc754d6425d11c0b6ee694828bdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sidebarPreviewLeaderboard$data = {
  readonly id: string;
  readonly ranking: {
    readonly users: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly totalPoints: number;
          readonly totalPointsCurrentMonth: number;
          readonly totalPointsLast3Months: number;
          readonly totalPointsLastMonth: number;
          readonly user: {
            readonly avatarFallback: string;
            readonly displayName: string | null | undefined;
            readonly photo: {
              readonly signedUrl: string;
            } | null | undefined;
            readonly username: string | null | undefined;
          };
        };
      }>;
    };
  };
  readonly " $fragmentType": "sidebarPreviewLeaderboard";
};
export type sidebarPreviewLeaderboard$key = {
  readonly " $data"?: sidebarPreviewLeaderboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"sidebarPreviewLeaderboard">;
};

import sidebarPreviewLeaderboardQuery_graphql from './sidebarPreviewLeaderboardQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": sidebarPreviewLeaderboardQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "sidebarPreviewLeaderboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClubRanking",
      "kind": "LinkedField",
      "name": "ranking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            },
            {
              "kind": "Literal",
              "name": "order",
              "value": "DESC"
            },
            {
              "kind": "Variable",
              "name": "orderBy",
              "variableName": "orderBy"
            }
          ],
          "concreteType": "RankingUserConnection",
          "kind": "LinkedField",
          "name": "users",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RankingUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RankingUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ImageFile",
                          "kind": "LinkedField",
                          "name": "photo",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "signedUrl",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "username",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "avatarFallback",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPoints",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPointsCurrentMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPointsLast3Months",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPointsLastMonth",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "f0b4c9ecb6a9adb62f8a3d12f35e6abc";

export default node;
